import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import PageTransition from "@/components/feature/PageTransition";
import NavigationProgress from "@/components/feature/NavigationProgress";
import ScrollToTop from "@/components/feature/ScrollToTop";
import ScrollRestoration from "@/components/feature/ScrollRestoration";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollRestoration />
        <NavigationProgress />
        <ScrollToTop />
        <PageTransition>
          <AppRoutes />
        </PageTransition>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
